export interface ProcessStatus {
  bigQuery: "idle" | "loading" | "success" | "error";
  recentArtists: "idle" | "loading" | "success" | "error";
  notifications: "idle" | "loading" | "success" | "error";
  message: string;
}

export interface ArtistNotificationResult {
  artistId: string;
  artistName: string;
  successCount: number;
  errorCount: number;
  totalUserCount: number;
}

export interface ProcessResults {
  processedArtists: ArtistNotificationResult[];
  totalSuccessCount: number;
  totalErrorCount: number;
}

export interface RecentlyUpdatedArtist {
  artistId: string;
  artistName: string;
  latestSongDate: string; // ISO 날짜 문자열
}

export interface GetRecentlyUpdatedArtistsResponse {
  data: RecentlyUpdatedArtist[];
  timestamp: string; // ISO 날짜 문자열
  periodStart: string; // ISO 날짜 문자열
}

// 커스텀 에러 클래스
export class APIError extends Error {
  constructor(
    message: string,
    public statusCode?: number,
    public originalError?: unknown
  ) {
    super(message);
    this.name = "APIError";
  }
}

export type DataObject = {
  f: [{ v: string }, { v: string }];
};

export type UserArtistPair = {
  userId: string;
  artistId: string;
};

export type ArtistUserGroups = {
  [key: string]: string[];
};
